import { ApolloClient, InMemoryCache, ApolloLink, concat, HttpLink } from "@apollo/client";
import fetch from "cross-fetch";
import { StoryblokConfig } from "../config/storyblok";
import apolloClient from "../graphql";
import { FETCH_MASTER_DATA } from "../graphql/queries/masterData";

const STORYBLOCK_GRAPHQL_API = `https://gapi.storyblok.com/v1/api`;

const storyBlokhttpLink = new HttpLink({
  uri: STORYBLOCK_GRAPHQL_API,
  fetch
});

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      token: StoryblokConfig.accessToken,
      version: "published"
    }
  }));
  return forward(operation);
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authMiddleware, storyBlokhttpLink)
});

export const fetchMasterData = async () => {
  try {
    const masterDataResponse = await apolloClient.mutate({
      mutation: FETCH_MASTER_DATA,
      variables: {
        cultureCode: "en-US"
      }
    });

    return masterDataResponse;
  } catch (error: any) {
    console.warn(`Error fetchMasterData: ${error.message}`);
    throw new Error(`Error fetchMasterData: ${error.message}`);
  }
};

export const getAirports = async () => {
  try {
    const airportDataResponse = await fetchMasterData();
    return airportDataResponse?.data?.stations?.values;
  } catch (error: any) {
    console.warn(error.message);
    throw new Error(`Error getAirports: ${error.message}`);
  }
};

export const fetchAppConfigData = async () => {
  try {
    const appConfigResponse = await client.query({
      query: CONFIG_APP_DATA
    });
    return appConfigResponse;
  } catch (error: any) {
    console.warn(`Error fetching app configuration data: ${error.message}`);
    throw new Error(`Error fetching app configuration data: ${error.message}`);
  }
};
